module.exports = __webpack_public_path__ + "static/media/rp02.1003c8a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/RilskaPrepravka/assets/rp02.jpg
// module id = 208
// module chunks = 0